;(function (angular, _) {
  'use strict'

  class autoSaveDisplay {
    constructor (
      // Angular
      $scope, $timeout, $interval
      // Libs
      // Managers
      // Services
      // Const
      // Resolved
    ) {
      this.$scope = $scope
      this.$timeout = $timeout
      this.interval = null
      this.width = null
      this.internalDelay = 0
      this.loadBarWidth = '100%'
      this.showLoadBar = false
      this.$interval = $interval
      this.displayIntervalTimer = null
    }

    $onInit () {
      this.$scope.$watch(() => this.trigger, (newValue, oldValue) => {
        if (this.showLoadBar) this.$timeout.cancel(this.showLoadBarTimeout)
        if (!newValue) this.showLoadBar = false
        if (newValue) {
          if (this.displayIntervalTimer) this.$interval.cancel(this.displayIntervalTimer)
          this.internalDelay = parseInt(angular.copy(this.delay) / 1000)
          this.showLoadBar = true
          this.initLoadBar()
          this.displayIntervalTimer = this.$interval(
            () => {
              this.internalDelay = this.internalDelay - 1
              if (this.internalDelay <= 0) this.$interval.cancel(this.displayIntervalTimer)
            }, 1000)
          this.showLoadBarTimeout = this.$timeout(() => {
            this.showLoadBar = false
          }, this.delay)
        }
      })
    }

    $onDestroy () {
      // Annule les timers en cours pour ne pas les laisser tourner après la destruction
      if (this.displayIntervalTimer) this.$interval.cancel(this.displayIntervalTimer)
      if (this.showLoadBarTimeout) this.$timeout.cancel(this.showLoadBarTimeout)
    }

    initLoadBar () {
      // keyframe
      document.querySelector('#autoSaveLoadBar').animate([
        { width: '100%' },
        { width: '0%' }
      ], {
        duration: this.delay
      })
    }
  }

  autoSaveDisplay.$inject = [
    // Angular
    '$scope', '$timeout', '$interval'
    // Libs
    // Managers
    // Services
    // Const
    // Resolved
  ]

  angular.module('kilo.common.components')
    .component('autoSaveDisplay', {
      bindings: {
        delay: '<',
        trigger: '=',
        cancel: '&'
      },
      controllerAs: '$ctrl',
      templateUrl: '/app/common/components/autosave-display/autosavedisplay.template.html',
      controller: autoSaveDisplay
    })
})(window.angular, window._)
